export const environment = {
  ct: 245,
  theme: 'default-theme',
  formAppearance: 'fill',
  reCaptchaSiteKey: '',
};
